import React from 'react';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
const validationSchema = Yup.object().shape({
  document: Yup.string().required('Required')
});
const UtilityBillContainer = props => {
  return (
    <Formik
      initialValues={{
        document: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting
      }) => {
        let documentList = [
          {
            label: 'LPG',
            value: 'LPG'
          },
          {
            label: 'PNG',
            value: 'PNG'
          },
          {
            label:'Electricity Bill',
            value:'Electricity Bill'
          }


        ];
        // const { box } = styles;
        handleChange = val => {
          console.log(val);
        };
        return (
          <Form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="pt-2 sm:px-5 mx-5"
          >
            {/* <div className={`${box}`}> */}
              <div className="w-full mr-auto py-3 max-w-xs ">
                <CommonSelect sort={true}
                  name="document"
                  value={values.document}
                  onChange={e => {
                    setFieldValue('document', {
                      value: e.value,
                      label: e.value
                    }),
                      handleChange(e.value);
                      props.setSelectedUtilityBill( e.value)
                  }}
                  options={[...documentList]}
                  isHoverEffect
                  stylesContainer={{
                    height: '52px',
                    marginBottom: '0px',
                    fontSize: '40px'
                  }}
                  dropdownStyle={{
                    top: '52px',
                    color: 'rgba(0,0,0,0.87)',
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    alignItems: 'center',
                    fontFamily: 'Roboto',
                    fontWeight: 400
                  }}
                  styleText={{
                    fontSize: '14px',
                    padding: '0 25px'
                  }}
                  error={
                    touched.document && get(errors, 'document.value', false)
                  }
                  touched={touched.document}
                  onBlur={e => {
                    () => {};
                  }}
                />
              </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default UtilityBillContainer;
